import { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { getInitialData } from "../utils/requests";
import { Option, SensorDetailsProps } from "../types";

function SensorDetails({
  sensor,
  selectedIDOption,
  setSelectedIDOption,
}: SensorDetailsProps) {
  const [mlVariant, setMlVariant] = useState("ml1");
  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    setSelectedIDOption("none"); // Reset the ID when sensor changes

    const fetchData = async () => {
      try {
        const data = await getInitialData(sensor.Latitude, sensor.Longitude);
        const formattedOptions: Option[] = data.map((item: string) => ({
          key: item,
          value: item,
        }));
        setOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [sensor, setSelectedIDOption]);

  return (
    <Box pb={2} pt={0.2}>
      <Typography variant="body1" gutterBottom>
        <strong>Sensor/Region: </strong>
        {sensor.region}
      </Typography>
      <FormControl fullWidth size="small">
        <InputLabel id="id">Choose an ID</InputLabel>
        <Select
          value={selectedIDOption}
          onChange={(e) => setSelectedIDOption(e.target.value)}
          label="Choose an ID"
        >
          <MenuItem key="none" value="none">
            None
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option.key} value={option.value}>
              {option.value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography variant="body1" gutterBottom>
        <strong>AQS: </strong>
        {sensor.AQS_Site_ID}
      </Typography>
      <FormControl fullWidth size="small">
        <InputLabel id="ml">ML Calibrated value</InputLabel>
        <Select
          value={mlVariant}
          onChange={(e) => setMlVariant(e.target.value)}
          label="ML Calibrated value"
          disabled
        >
          <MenuItem value="ml1">ML1</MenuItem>
          <MenuItem value="ml2">ML2</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}

export default SensorDetails;
